var http = require('./lib/http');

var https = http;
var URL = self.URL;
module.exports = {
  http: http,
  https: https,
  getRequest: function getRequest(options, cb) {
    var protocol = 'http:';

    if (typeof options === 'string') {
      var url = new URL(options);
      protocol = url.protocol;
    } else if (options.protocol) {
      protocol = options.protocol;
    }

    return protocol === 'http:' ? http.request(options, cb) : https.request(options, cb);
  }
};